import {
  ABOUT_ROUTE,
  CONTACTS_ROUTE,
  INDEX_ROUTE, LOTTERY_ROUTE, SLOT_MACHINES_ROUTE, SOLUTION_CASINO_ROUTE
} from "./utils/consts";
import IndexPage from "./pages/IndexPage";
import ContactsPage from "./pages/ContactsPage";
import SlotMachinesPage from "./pages/SlotMachinesPage";
import SolutionsCasinoPage from "./pages/SolutionsCasinoPage";
import LotteryPage from "./pages/LotteryPage";
import AboutPage from "./pages/AboutPage";

export const publicRoutes = [
  {path: INDEX_ROUTE, Component: IndexPage, name: "Головна"},
  {path: SLOT_MACHINES_ROUTE, Component: SlotMachinesPage, name: "Ігрові автомати"},
  {path: SOLUTION_CASINO_ROUTE, Component: SolutionsCasinoPage, name: "Рішення для Казино"},
  // {path: ONLINE_SOLUTION_ROUTE, Component: OnlineSolutionsPage, name: "Онлайн рішення"},
  {path: LOTTERY_ROUTE, Component: LotteryPage, name: "Лотереї"},
  // {path: GAMES_ROUTE, Component: GamesPage, name: "Ігри"},
  {path: ABOUT_ROUTE, Component: AboutPage, name: "Про нас"},
  {path: CONTACTS_ROUTE, Component: ContactsPage, name: "Зворотний зв'язок"},
  // {path: GAMES_ROUTES, Component: GamePage, name: "Ігри"},
];